import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Phone, Mail, Clock, User } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';
import { trackEmailClick, trackPhoneClick } from '../lib/metrikaGoals';
import RequestCalculationForm from './RequestCalculationForm';

const MeetingPopup = ({ open, onOpenChange }) => {
  const [imageError, setImageError] = useState(false);
  const [isCallbackFormOpen, setIsCallbackFormOpen] = useState(false);

  const contactInfo = {
    phone: companyInfo.contact.phone || '+7-921-888-63-63',
    email: companyInfo.contact.email,
    workingHours: companyInfo.contact.workingHours || 'Пн-Пт: 10:00 - 19:00 МСК',
  };

  const openCallbackForm = () => {
    onOpenChange(false);
    setIsCallbackFormOpen(true);
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="text-2xl">Свяжитесь с нами</DialogTitle>
          </DialogHeader>

          <div className="grid md:grid-cols-2 gap-6 mt-4">
            {/* Левая часть - фотография */}
            <div className="flex flex-col items-center justify-center">
              <div className="relative mb-4">
                {!imageError ? (
                  <img
                    src="/images/contact-logo.png"
                    alt="Антология"
                    className="w-48 h-48 md:w-56 md:h-56 rounded-full object-contain border-4 border-accent/20 shadow-lg bg-white"
                    onError={() => setImageError(true)}
                  />
                ) : (
                  <div className="w-48 h-48 md:w-56 md:h-56 rounded-full bg-muted border-4 border-accent/20 shadow-lg flex items-center justify-center">
                    <User className="w-24 h-24 md:w-32 md:h-32 text-muted-foreground" />
                  </div>
                )}
              </div>
            </div>

            {/* Правая часть - контакты */}
            <div className="space-y-6">
              {/* Телефон */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center flex-shrink-0">
                  <Phone className="w-6 h-6 text-accent" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold mb-1">Телефон</h3>
                  <a
                    href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                    onClick={trackPhoneClick}
                    className="text-accent hover:underline text-lg"
                  >
                    {contactInfo.phone}
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-accent" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold mb-1">Email</h3>
                  <a
                    href={`mailto:${contactInfo.email}`}
                    onClick={trackEmailClick}
                    className="text-accent hover:underline"
                  >
                    {contactInfo.email}
                  </a>
                </div>
              </div>

              {/* Часы работы */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center flex-shrink-0">
                  <Clock className="w-6 h-6 text-accent" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold mb-1">Часы работы</h3>
                  <p className="text-muted-foreground">{contactInfo.workingHours}</p>
                </div>
              </div>

              <div className="pt-4">
                <Button
                  type="button"
                  className="w-full bg-accent hover:bg-accent/90 text-accent-foreground"
                  onClick={openCallbackForm}
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Обратный звонок
                </Button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <RequestCalculationForm
        open={isCallbackFormOpen}
        onOpenChange={setIsCallbackFormOpen}
      />
    </>
  );
};

export default MeetingPopup;
